// extracted by mini-css-extract-plugin
export default {"button":"xk-z","reviewSort":"yk-z"};